<template>
    <validation-observer  ref="pospone">
        <form class="formBox">
            <validation-provider v-if="data.allPostpone" :name="$t('signal.postpone.signalType')" :rules="{ required: true, is_not: 0}" v-slot="validationContext">
                <b-form-group class="inputGrp">
                    <b-row>
                        <b-col sm="4"> <label for="title"> {{$t('signal.postpone.signalType')}} </label> </b-col>
                        <b-col sm="8"> 
                            <Multiselect  
                                v-model="selectedType"
                                :show-labels="false" 
                                :options="signalGroups"
                                label="name"
                                :state="getValidationState(validationContext)"
                                track-by="id" >
                                    <template slot="singleLabel" slot-scope="{ option }">
                                        <strong>{{ option.name }} </strong> 
                                    </template>
                            </Multiselect>
                            <b-form-invalid-feedback id="live-feedback" style="display: block; width: 100%">
                                {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                        </b-col>
                    </b-row>
                </b-form-group>
            </validation-provider>
            <b-form-group>
                <b-row> 
                    <b-col sm="4"> <label for="state"> {{$t('signal.postpone.postponeType')}} </label> </b-col>
                    <b-col sm="8" class="multiItems">
                        <b-form-radio-group
                            id="state"
                            v-model="state"
                            :options="states"
                            aria-describedby="live-feedback">
                        </b-form-radio-group>
                    </b-col>
                </b-row>
            </b-form-group>
            <validation-provider :name="$t('signal.postpone.time')" :rules="{ required: true}" v-slot="validationContext">
                <b-form-group class="inputGrp">
                    <b-row>
                        <b-col sm="4"> <label for="title"> {{$t('signal.postpone.time')}} </label> </b-col>
                        <b-col sm="8"> 
                            <Datetime v-model="time" type="time"></Datetime>
                            <b-form-invalid-feedback id="live-feedback" style="display: block; width: 100%">
                                {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                        </b-col>
                    </b-row>
                </b-form-group>
            </validation-provider>
            <validation-provider :name="$t('signal.postpone.signalNote')" :rules="{ required: true }" v-slot="validationContext">
                <b-form-group class="inputGrp">
                    <b-row>
                        <b-col sm="4"> <label for="title"> {{$t('signal.postpone.signalNote')}} </label> </b-col>
                        <b-col sm="8"> 
                            <b-form-textarea 
                            id="note"
                            rows="3"
                            v-model="note"
                            :state="getValidationState(validationContext)"
                            aria-describedby="live-feedback"
                        ></b-form-textarea>
                            <b-form-invalid-feedback id="live-feedback" style="display: block; width: 100%">
                                {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                        </b-col>
                    </b-row>
                </b-form-group>
            </validation-provider>
            <b-button v-if="data.type == 'process'" variant="primary" @click="manuelClick()"> {{$t('signal.actions.bulk')}}</b-button>
        </form>
    </validation-observer>
</template>

<style lang="css" scoped > 
    @import "../styles/add.min.css"; 
</style>

<script>
    import i18n from '@/plugins/i18n';
    import Multiselect from 'vue-multiselect'
    import { Datetime } from 'vue-datetime';
    import moment from 'moment'
    import { VueEditor } from "vue2-editor";
    import jwt_decode from "jwt-decode";

    let states = [
        {text: i18n.t('signal.postpone.hourMinPostpone'), value: 0},
        {text: i18n.t('signal.postpone.hourPostpone'), value: 1}
    ]
    export default {
        name: "PostPone",
       
        data: function() {
            return {
                time: null,
                state: 0,
                note: '',
                selectedType: null,
                states
            }
        },
        props: {
            data: Object,
            save: Boolean,
            saveState: Function,
            modalName: String,
            modalEvent: Function,
            getSignal: Function
        },
        methods:{
            getValidationState({ dirty, validated, valid = null }) {
                return dirty || validated ? valid : null;
            },
            manuelClick(){
                this.save = true
            }
        },
        components:{
            Multiselect, Datetime, VueEditor
        },
        computed:{
            signalGroups() {
                return this.$store.getters.getSignalGroups;
            },
        },
        watch: {
            save: function(data){
                if(data){
                    this.$refs.pospone.validate().then( async (success) =>{
                            if(success){
                                if(this.data.allPostpone){
                                    //Toplu Sinyal Ertele
                                     let params =  {
                                        "user_id": jwt_decode(localStorage.getItem('access_token')).user_id,
                                        "event" : "bulkOperation",
                                        "bulk_type" : 1, //toplu
                                        "signal_group_id": this.selectedType.ID,
                                        "note": this.note,
                                        "postpone_info":{
                                            "postpone_type": this.state,
                                            "postpone_time":moment(String(this.time)).format('HH:mm') 
                                        }
                                    }
                                    this.$socket.send(JSON.stringify(params))
                                    this.getSignal()
                                    this.modalEvent(false)
                                }else{
                                    //Tekli Sinyal Ertelee
                                    let params =  {
                                        "user_id": jwt_decode(localStorage.getItem('access_token')).user_id,
                                        "event" : "postponeSignal",
                                        "postpone_type": this.state,
                                        "postpone_time":moment(String(this.time)).format('HH:mm') ,
                                        signal_info:{
                                            "signal_id": this.data.id,
                                            "note": this.note
                                        }
                                    }
                                    this.$socket.send(JSON.stringify(params))
                                    if(this.data.type !== 'process'){
                                        this.getSignal()
                                    }
                                    this.modalEvent(false)

                                }

                            }


                        }
                    )

                }
                if(this.data.type == 'process'){
                    this.save = false
                }
                this.saveState(false)

            }
        }
        
    }
</script>


// WEBPACK FOOTER //
// src/pages/Alarmsis/Signal/modals/Postpone.vue